import React from "react";
import { getCurrentUser, getUsers, getUsersIdle } from "./actions";
import { selectUsers } from "./selector";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { RootState } from "src/store/rootReducer";
import { useLocation } from "react-router-dom";

const Users: React.FC = () => {
  const dispatch = useAppDispatch();
  const users = useAppSelector(selectUsers);
  const status: string = useAppSelector((state: RootState) => state.users.status);
  const location = useLocation();

  console.log('users', users)

  React.useEffect(() => {
    dispatch(getCurrentUser({ path: location.pathname }));
  }, []);

  React.useEffect(() => {
    if (status !== "IDLE") {
      return;
    }

    const usersRequests = Object.keys(users).filter((key) => !users[key]);
    if (usersRequests.length > 0) {
      dispatch(getUsers(usersRequests));
    }
  }, [dispatch, users, status]);

  React.useEffect(() => {
    if (status === "SUCCESS") {
      dispatch(getUsersIdle());
    }
  }, [dispatch, status]);

  return <></>;
};
export default Users;
